import Checking from "./ABC";

function App() {
  return (
    <div className="App">
      <Checking/>
    </div>
  );
}

export default App;
